import { PlannerApi } from "../Api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
export const usePlanner = ()=>{
    const queryClient = useQueryClient();
    const plannerApi = new PlannerApi();
    const usePlannerQuery = function() {
        let filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return useQuery([
            "trip-planner-resources",
            filters
        ], ()=>plannerApi.getPlannerResources(filters), {
            keepPreviousData: true
        });
    };
    const useProductItemsQuery = (productId)=>useQuery([
            "trip-planner",
            "items",
            productId
        ], ()=>plannerApi.getProductItems(productId));
    const useUserTripPlansQuery = ()=>useQuery([
            "trip-planner",
            "me"
        ], ()=>plannerApi.getUserTripPlans());
    const useTripPlanQuery = (plannerId)=>useQuery([
            "trip-planner",
            plannerId
        ], ()=>plannerApi.getTripPlan(plannerId));
    const usePlannerFiltersQuery = ()=>useQuery([
            "trip-planner-filters"
        ], ()=>plannerApi.getFilters());
    const useSaveTripPlanMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return useMutation((data)=>plannerApi.saveTripPlan(data), {
            onSuccess,
            onError
        });
    };
    const useDeleteTripPlanMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return useMutation((data)=>plannerApi.deleteTripPlan(data), {
            onSuccess: async function() {
                for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
                    props[_key] = arguments[_key];
                }
                await queryClient.invalidateQueries([
                    "trip-planner",
                    "me"
                ]);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(...props);
            },
            onError
        });
    };
    return {
        usePlannerQuery,
        useProductItemsQuery,
        useSaveTripPlanMutationQuery,
        useUserTripPlansQuery,
        useDeleteTripPlanMutationQuery,
        useTripPlanQuery,
        usePlannerFiltersQuery
    };
};
